import { render, staticRenderFns } from "./UserReferralReferrals.vue?vue&type=template&id=33903247&scoped=true&"
import script from "./UserReferralReferrals.vue?vue&type=script&lang=js&"
export * from "./UserReferralReferrals.vue?vue&type=script&lang=js&"
import style0 from "./UserReferralReferrals.vue?vue&type=style&index=0&id=33903247&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33903247",
  null
  
)

export default component.exports